<template lang="pug">
  div.navbar-section
    .dropdown.dropdown-right.tooltip.tooltip-left(data-tooltip='Departamento')
      a.btn.btn-link.dropdown-toggle.text-primary(tabindex='0')
        i.fa.fa-lg.fa-sitemap
        span  {{ current ? current.nome : 'Departamento...' }}&nbsp;
        i.fa.fa-caret-down
      ul.menu
        li.menu-item
          router-link.text-primary(:to="{name: 'departamentos'}")
            i.fa.fa-exchange
            | &nbsp;Alterar
    .btn.tooltip.tooltip-bottom.text-primary.bg-primary-light(@click='update' v-if="waitingWorker" data-tooltip='Nova versão disponível')
      .fa.fa-refresh
      | &nbsp;Atualizar
    .dropdown.dropdown-right(v-if='usuario')
      a.btn.btn-link.dropdown-toggle.text-primary(tabindex='0')
        object.avatar.avatar-sm(:data='usuario.url_thumb', type='image/png')
          img(src='@/assets/user.png')
        span.hide-sm &nbsp;{{usuario.nome.split(' ')[0]}}
        | &nbsp;
        i.fa.fa-caret-down
      ul.menu
        li.menu-item.c-hand
          a.text-primary(@click='authHome')
            i.fa.fa-user.fa-fw
            | &nbsp;Gerenciar conta
        li.divider
        li.menu-item.c-hand
          a.text-error(@click='sair')
            i.fa.fa-power-off.fa-fw
            | &nbsp;Sair
</template>

<script>
import auth from "@/config/auth"

export default {
  vuex: {
    departamentos: {
      state: ["current"],
    },
    session: {
      state: ["usuario"],
      actions: ["fetchUsuario", "signOut"],
    },
    serviceWorker: {
      state: ["waitingWorker"],
      actions: ["update"],
    },
  },

  methods: {
    authHome() {
      return this.$auth.home()
    },

    sair() {
      const options = {
        title: "Sair",
        okLabel: "Sair",
        cancelLabel: "Cancelar",
        size: "sm",
      }
      return this.$dialogs
        .confirm("Tem certeza que deseja sair?", options)
        .then(({ ok }) => {
          if (ok) {
            this.signOut().then(() => {
              this.$router.replace({ path: "/" })
            })
          }
        })
    },
  },

  created() {
    this.fetchUsuario()
  },
}
</script>

<style lang="stylus" scoped>
.avatar
  background-color #fff

  img
    background-color #fff
</style>
